import StackedBarChartRole from 'config/chart-types/bar-stacked';
import StackedColumnChartRole from 'config/chart-types/column-stacked';
import DiscreteLineChartRole from 'config/chart-types/line-discrete';
import ContinuousLineChartRole from 'config/chart-types/line-continuous';
import DonutChartRole from 'config/chart-types/donut';
import ScatterPlotRole from 'config/chart-types/scatter';
import DiscreteAreaChartRole from 'config/chart-types/area-discrete';
import StackedArea100ChartRole from 'config/chart-types/area-100-stacked';
import ContinuousAreaChartRole from 'config/chart-types/area-continuous';
import GroupedBarChartRole from 'config/chart-types/bar-grouped';
import GroupedColumnChartRole from 'config/chart-types/column-grouped';
import ColoredColumnChartRole from 'config/chart-types/column-colored';
import ColoredBarChartRole from 'config/chart-types/bar-colored';
import Stacked100BarChartRole from 'config/chart-types/bar-100-stacked';
import Stacked100ColumnChartRole from 'config/chart-types/column-100-stacked';
import HeatmapRole from 'config/chart-types/heatmap';
import NumberRole from 'config/chart-types/number';
import WordCloudRole from 'config/chart-types/word-cloud';
import TABLE_ROLES from 'config/table-types';
import MAP_ROLES from 'config/map-types';
import D3_ROLES from 'config/d3-types';

const CHART_ROLES = [
  DiscreteAreaChartRole,
  StackedBarChartRole,
  DiscreteLineChartRole,
  DonutChartRole,
  ScatterPlotRole,
  StackedArea100ChartRole,
  StackedColumnChartRole,
  ContinuousLineChartRole,
  ContinuousAreaChartRole,
  GroupedBarChartRole,
  GroupedColumnChartRole,
  ColoredColumnChartRole,
  ColoredBarChartRole,
  Stacked100BarChartRole,
  Stacked100ColumnChartRole,
  HeatmapRole,
  NumberRole,
  WordCloudRole,
  ...TABLE_ROLES,
  ...MAP_ROLES,
  ...D3_ROLES,
];

const isTableType = chartType =>
  TABLE_ROLES.some(table => table.name === chartType);
const isMapType = chartType => MAP_ROLES.some(map => map.name === chartType);
const isD3Type = chartType => D3_ROLES.some(map => map.name === chartType);

export { CHART_ROLES, isTableType, isMapType, isD3Type };
